import axios from "axios";
import { API_BASE_URL } from "../config/apiConfig";


export const getStudents = async () => {
  const response = await axios.get(`${API_BASE_URL}/users/getStudents`);
  return response.data.data; // Retorna solo la lista de estudiantes
};

export const getTeachers = async () => {
  const response = await axios.get(`${API_BASE_URL}/users/getTeachers`);
  return response.data.data; // Retorna solo la lista de profesores
};

export const getSalones = async () => {
  const response = await axios.get(`${API_BASE_URL}/salones`);
  return response.data.salones; // Retorna solo la lista de salones
};

export const getAsignaturas = async () => {
  const response = await axios.get(`${API_BASE_URL}/asignaturas`);
  return response.data.asignaturas; // Retorna solo la lista de asignaturas
};

export const getUserById = async (id) => {
  const token = localStorage.getItem("authToken");
  const headers = {
    Authorization: `${token}`,
  };
  const response = await axios.get(`${API_BASE_URL}/users/${id}`, { headers });
  return response.data.data;
};

export const getStudentsByDirector = async () => {
  const token = localStorage.getItem("authToken");
  const headers = {
    Authorization: `${token}`,
  };
  const response = await axios.get(
    `${API_BASE_URL}/students/getStudentsByDirector`,
    { headers }
  );
  return response.data.data; // Asume que el backend retorna un array de estudiantes en data.data
};

// Obtener asignaturas y salones para profesores
export const getCoursesByTeacher = async () => {
  const token = localStorage.getItem("authToken");
  const headers = {
    Authorization: `${token}`,
  };
  const response = await axios.get(`${API_BASE_URL}/teachers/courses`, {
    headers,
  });
  return response.data;
};

// Obtener el salón y grado para estudiantes
export const getSalonByStudent = async () => {
  const token = localStorage.getItem("authToken");
  const headers = {
    Authorization: `${token}`,
  };
  const response = await axios.get(`${API_BASE_URL}/students/salon`, {
    headers,
  });
  return response.data;
};

export const getSalonByDirector = async () => {
  const token = localStorage.getItem("authToken");
  const headers = {
    Authorization: `${token}`,
  };
  const response = await axios.get(`${API_BASE_URL}/salon/director`, {
    headers,
  });
  return response.data.data;
};

export const createTeacher = async (teacherData) => {
  const token = localStorage.getItem("authToken"); // Obtén el token del almacenamiento
  const headers = {
    Authorization: `${token}`,
  };
  const response = await axios.post(
    `${API_BASE_URL}/users/createTeacher`,
    teacherData,
    { headers }
  );
  return response.data;
};

export const createStudent = async (studentData) => {
  const token = localStorage.getItem("authToken"); // Obtén el token del almacenamiento
  const headers = {
    Authorization: `${token}`,
  };
  const response = await axios.post(
    `${API_BASE_URL}/users/createStudent`,
    studentData,
    { headers }
  );
  return response.data;
};

export const updateTeacher = async (id, teacherData) => {
  const token = localStorage.getItem("authToken");
  const headers = {
    Authorization: `${token}`,
  };

  const response = await axios.put(
    `${API_BASE_URL}/users/update/${id}`,
    teacherData,
    { headers }
  );
  return response.data;
};

export const updateStudent = async (id, studentData) => {
  const token = localStorage.getItem("authToken");
  const headers = {
    Authorization: `${token}`,
  };

  const response = await axios.put(
    `${API_BASE_URL}/users/update/${id}`,
    studentData,
    { headers }
  );
  return response.data;
};

export const deleteUserService = async (userId) => {
  const token = localStorage.getItem("authToken"); // Obtén el token del almacenamiento local
  const headers = {
    Authorization: `${token}`,
  };

  const response = await axios.delete(`${API_BASE_URL}/users/${userId}`, {
    headers,
  });
  return response.data;
};
